module.exports = __webpack_public_path__ + "src/assets/img/m50.cb343782.svg";